import {XauditModel} from '../xaudit.model';

export class AppointmentDocumentDataModel extends XauditModel {
  AppointmentDocId: string;
  AppointmentId: string;
  PatientId: string;
  DocFrom: string;
  Description: string;
  DocumentID: string;
  OriginalFileName: string;

  // Front end use only (Used prior to upload)
  file: File;
}
